export const WINDING_DOFF_ENTRY_LIST = "winding_doff_entry_list";
export const WINDING_DOFF_ENTRY_LIST_SUCCESSFULL = "winding_doff_entry_list_successfull";
export const WINDING_DOFF_ROW_DELETE = "wining_doff_row_delete"
export const WINDING_DOFF_ROW_DELETE_SUCCESSFULL = "wining_doff_row_delete_successfull"
export const TROLLY_DD_LIST = "trolly_dd_list";
export const TROLLY_DD_LIST_SUCCESSFULL = "trolly_dd_list_successfull";
// export const BEAMING_CREATE = "beaming_create";
// export const BEAMING_CREATE_SUCCESSFULL = "beaming_create_successfull";
